import OLViewProperty from 'ol/ViewProperty';

export const ViewProperty = Object.assign({
  MAX_EXTENT: 'maxExtent',
  PROJECTION_TITLE: 'projectionTitle',
  USES_DEFAULT_SRS: 'usesDefaultSrs'
}, OLViewProperty);
